import { emojisRegex } from './constants';

export default (name: string, limit: number = 4): string => {
  if (!name) return '';
  const clearedFromEmojis = name.replace(new RegExp(emojisRegex, 'ug'), '');

  let initials = '';
  const nameParts = clearedFromEmojis.split(' ');
  const sliceAt = limit || nameParts.length;

  nameParts.slice(0, sliceAt).forEach((word) => {
    if (word) {
      initials += word[0].toUpperCase();
    }
  });

  return initials;
};
